import { memo } from 'react'

import { PartnerFields } from 'clickNgo/entities/partner/configs'
import { FormInput } from 'cng-common/features/form'
import { FieldGroup } from 'shared/components/fieldGroup/FieldGroup'

import { partnerAdditionalTranslation } from '../../translation'

import { ISocialBlockProps } from './models'

export const SocialBlock = memo<ISocialBlockProps>(
  ({
    formKeys,
    isDisabled,
    isReadOnly,
    facebookLink,
    linkedInLink,
    twitterLink,
    whatsAppLink,
    onFacebookLinkValidate,
    onLinkedInLinkValidate,
    onTwitterLinkValidate,
    onWhatsAppLinkValidate,
    isFacebookLinkRequired,
    isLinkedInLinkRequired,
    isTwitterLinkRequired,
    isWhatsAppLinkRequired,
  }) => {
    return (
      <FieldGroup title={partnerAdditionalTranslation.content.blockTitles.socialBlock}>
        <FormInput
          field={PartnerFields.linkedInLink.field}
          label={PartnerFields.linkedInLink.label}
          formKey={formKeys.additional}
          defaultValue={linkedInLink}
          onValidate={onLinkedInLinkValidate}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          isRequired={isLinkedInLinkRequired}
        />
        <FormInput
          field={PartnerFields.facebookLink.field}
          label={PartnerFields.facebookLink.label}
          formKey={formKeys.additional}
          defaultValue={facebookLink}
          onValidate={onFacebookLinkValidate}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          isRequired={isFacebookLinkRequired}
        />
        <FormInput
          field={PartnerFields.twitterLink.field}
          label={PartnerFields.twitterLink.label}
          formKey={formKeys.additional}
          defaultValue={twitterLink}
          onValidate={onTwitterLinkValidate}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          isRequired={isTwitterLinkRequired}
        />
        <FormInput
          field={PartnerFields.whatsAppLink.field}
          label={PartnerFields.whatsAppLink.label}
          formKey={formKeys.additional}
          defaultValue={whatsAppLink}
          onValidate={onWhatsAppLinkValidate}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          isRequired={isWhatsAppLinkRequired}
        />
      </FieldGroup>
    )
  }
)
